import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Typography,
} from '@deere/fuel-react';
import Configuration from '@deere/ux.brand-foundations/icons/configuration.svg';
import EditIcon from '@deere/ux.brand-foundations/icons/edit.svg';
import Note from '@deere/ux.brand-foundations/icons/note.svg';
import TaskList from '@deere/ux.brand-foundations/icons/task_list.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css';

export const Home = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.homeContainer}>
            <Grid container spacing={6} style={{ maxWidth: '80%' }}>
                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                <img
                                    alt=">>"
                                    src={TaskList}
                                    className={styles.svgIcon}
                                />
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                >
                                    View All Posted Job Bids & Bidders
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="sm"
                                paddingTop="0.50rem"
                            >
                                View all open job bids, edit bidders, and
                                download a complete list.
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() => navigate('/active-jobs')}
                                >
                                    View All Active Job Bids
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                <img
                                    alt=">>"
                                    src={Configuration}
                                    className={styles.svgIcon}
                                />
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                    size="large"
                                >
                                    Create New Job Bid
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="sm"
                                paddingTop="0.50rem"
                            >
                                Create a new job bid posting.
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() => navigate('/create-job')}
                                >
                                    Create New Job
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                <img
                                    alt=">>"
                                    src={Note}
                                    className={styles.svgIcon}
                                />
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                    size="large"
                                >
                                    View Closed Job Bids & Bidders
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="small"
                                paddingTop="0.50rem"
                            >
                                View all closed job bids and download a list of
                                successful bidders.
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() => navigate('/closed-jobs')}
                                >
                                    View All Closed Jobs
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>

                <Grid item sm={6} xs={12}>
                    <Card>
                        <CardContent sx={{ paddingBottom: '0rem' }}>
                            <Box display="flex" alignItems="center" gap="1rem">
                                <img
                                    alt=">>"
                                    src={EditIcon}
                                    className={styles.svgIcon}
                                />
                                <Typography
                                    gutterBottom
                                    variant="h3"
                                    component="h2"
                                    size="large"
                                >
                                    Edit Job Bids Before They Go Live
                                </Typography>
                            </Box>
                            <Typography
                                color="secondary"
                                size="sm"
                                paddingTop="0.50rem"
                            >
                                View or edit all pending jobs and download a
                                complete list.
                            </Typography>
                        </CardContent>
                        <Box>
                            <CardActions justifyContent="flex-start">
                                <Button
                                    variant="primary"
                                    onClick={() => navigate('/pending-jobs')}
                                >
                                    View Pending Jobs
                                </Button>
                            </CardActions>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};
